import { createFileRoute } from '@tanstack/react-router';

import { AddActivityForm } from '@/areas/manufacturing-templates/Activities/ActivityCreation/AddActivityForm';
import { canCreateManufacturingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';
import { PageLayout } from '@/shared/ui/PageLayout';

export const Route = createFileRoute('/_authenticated/manufacturing/activities/create')({
    staticData: { access: { permissions: canCreateManufacturingTemplates }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return (
        <PageLayout layout="full-width">
            <AddActivityForm />
        </PageLayout>
    );
}
